import React from "react"
import { connect } from "react-redux"
import Header from "../components/shared/header"
import Sidebar from "../components/shared/sidebar"
import HelpPanel from "../components/help/helpPanel"

const HelpContainer = (props) => {
  return (
    <div>
        <Header loggedInUser = { props.loggedInUser } />
        <main className="wrapper">
        <Sidebar />
        <div className="content-wrapper">
          <div className="content__inner">
            <HelpPanel />
          </div>
        </div>
      </main>
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({
  loggedInUser: auth.loggedInUser
})

export default connect(mapStateToProps)(HelpContainer)
